import React from "react";
import { observer } from "mobx-react-lite";
import { Form, Field, Formik } from "formik";
import Input from "../../../FormComponents/Input";
import { Instagram, Tiktok, Youtube } from "react-bootstrap-icons";
import axiosService from "../../../../utils/AxiosService";
import { toastSuccess, toastError } from "../../../FormComponents/Toasts";
import { NewAuthenticationSchema } from "../../../../schemas/NewAuthenticationSchema";
import { useNavigate } from "react-router-dom";


export default observer(function NewInfluencerModashForm({ setIsOpen, infId }) {
  const navigate = useNavigate()

  const handleSubmit = (authentication) => {
    // Returning the promise lets Formik track `isSubmitting` for us.
    return axiosService.post('/api/project_manager/authentications', {
      authentication: {
        username: authentication.username,
        provider: authentication.provider,
        influencer_id: authentication.influencer_id,
      }
    })
      .then((resp) => {
        if (resp.message) {
          toastSuccess(resp.message)
          setIsOpen(false)
        } else if (resp.id) {
          setIsOpen(false)
          navigate(`/project_manager/authentications/${resp.id}/influencer/overview`)
        }
      })
      .catch((response) => toastError(response?.data?.error || 'Something went wrong'))
    }

  const ButtonSpinner = () => <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />

  return (
    <Formik
      initialValues={{
        username: '',
        provider: '',
        influencer_id: infId || ''
      }}
      validationSchema={NewAuthenticationSchema}
      onSubmit={handleSubmit}
    >
      {({ handleBlur, handleChange, values, touched, errors, setFieldValue, isSubmitting }) => (
        <Form className="flex flex-col">
          <div className="flex-1">
            <div className="form-item-container w-full pt-4">
              <p className="text-sm pl-4 pb-1 dark:text-white">Provider</p>
              <div>
                <span role="group" className="ml-4 inline-flex items-center gap-8 rounded-lg bg-rb-grey dark:bg-rb-dark-mode-lighter p-4">
                  <label className={`${values.provider === 'instagram' ? 'bg-rb-soft-green dark:bg-rb-green/20 border-rb-green dark:border-rb-green' : 'bg-white dark:bg-rb-dark-mode'} cursor-pointer text-pink-600 dark:text-pink-400 w-12 h-12 flex items-center justify-center border-1 dark:border-rb-dark-mode-lighter rounded-md`}>
                    <Field type="radio" name="provider" value="instagram" className="hidden" onChange={(e) => setFieldValue('provider', e.target.value)} />
                    <Instagram />
                  </label>
                  <label className={`${values.provider === 'tiktok' ? 'bg-rb-soft-green dark:bg-rb-green/20 border-rb-green dark:border-rb-green' : 'bg-white dark:bg-rb-dark-mode text-black dark:text-white'} cursor-pointer w-12 h-12 flex items-center justify-center border-1 dark:border-rb-dark-mode-lighter rounded-md`}>
                    <Field type="radio" name="provider" value="tiktok" className="hidden" onChange={(e) => setFieldValue('provider', e.target.value)} />
                    <Tiktok />
                  </label>
                  <label className={`${values.provider === 'youtube' ? 'bg-rb-soft-green dark:bg-rb-green/20 border-rb-green dark:border-rb-green' : 'bg-white dark:bg-rb-dark-mode'} cursor-pointer text-red-500 dark:text-red-400 w-12 h-12 flex items-center justify-center border-1 dark:border-rb-dark-mode-lighter rounded-md`}>
                    <Field type="radio" name="provider" value="youtube" className="hidden" onChange={(e) => setFieldValue('provider', e.target.value)} />
                    <Youtube />
                  </label>
                </span>
                {touched.provider && errors.provider && (
                  <div className="text-red-500 dark:text-red-400 text-sm ml-4 mt-1">{errors.provider}</div>
                )}
              </div>

              <div className="form-item-container w-full px-4">
                <Input
                  error={touched.username && errors.username}
                  placeholder="Username"
                  name='username'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.username}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-between pt-4 bg-white dark:bg-rb-dark-mode">
            <button
              type='button'
              className='rb-btn-cancel font-bold text-md ml p-2 px-4 rounded-lg disabled:opacity-50'
              disabled={isSubmitting}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="ml-2 flex items-center gap-2 bg-rb-green text-white rounded-lg p-2 px-4 submit text-center active:shadow-outer active:shadow-rb-green border-rb-green dark:text-rb-dark-mode disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting && <ButtonSpinner />}
              {isSubmitting ? 'Creating...' : 'Create'}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
})
